import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetPayerDistributionRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

const GetPayerDistributionResponseDtoSchema = z.object({
  facility: z.object({
    medicaid: z.object({
      residents: z.number(),
      residentsPct: z.number(),
      revenue: z.number(),
      revenuePct: z.number(),
    }),
    private: z.object({
      residents: z.number(),
      residentsPct: z.number(),
      revenue: z.number(),
      revenuePct: z.number(),
    }),
  }),
  market: z.object({
    medicaid: z.object({
      residents: z.number(),
      residentsPct: z.number(),
      revenue: z.number(),
      revenuePct: z.number(),
    }),
    private: z.object({
      residents: z.number(),
      residentsPct: z.number(),
      revenue: z.number(),
      revenuePct: z.number(),
    }),
  }),
});

export type GetPayerDistributionRequestDto = z.infer<
  typeof _GetPayerDistributionRequestDtoSchema
>;
export type GetPayerDistributionResponseDto = z.infer<
  typeof GetPayerDistributionResponseDtoSchema
>;

export const getPayerDistributionChart = async (
  params: GetPayerDistributionRequestDto,
  config?: AxiosRequestConfig<GetPayerDistributionRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/payer-distribution`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetPayerDistributionResponseDtoSchema));
};
